<div class="form-group">
    <label class="input-label">Min length</label>
    <input class="form-control"
           name="required"
           type="number"
           [(ngModel)]="fieldOptions.validate.minLength">
</div>